var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/verifiedTick.8c3a27f2.png","uri@2x": __webpack_public_path__ + "static/media/verifiedTick.de01a21c.png","uri@3x": __webpack_public_path__ + "static/media/verifiedTick.b3b055a1.png",
    width: 24,
    height: 24
});